<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }">
    <i class="fas fa-flag mr-1" />
    {{ text }}
  </FilterBadge>
</template>

<script setup lang="ts">
import { gql } from "@apollo/client/core";
import { computed, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import apolloCache from "@/graphql/apolloCache";
import FlagsFilter from "../../filterImplementations/FlagsFilter";
import FilterBadge from "./FilterBadge.vue";
import joinList from "./joinList";

const props = defineProps({
  filter: {
    type: Object as PropType<FlagsFilter>,
    required: true,
  },
});

const { t, te } = useTranslation();
const text = computed(() => {
  const filterNames = props.filter.flags.map((flagId) => {
    const { displayNameId, abbreviationId, name, id } = apolloCache.readFragment<{
      displayNameId: number;
      abbreviationId: number;
      id: number;
      name: string;
    }>({
      id: `Flag:${flagId}`,
      fragment: gql`
        fragment displayNameId on Flag {
          displayNameId
          abbreviationId
          id
          name
        }
      `,
    }) ?? { displayNameId: null };
    return te(`dynamic.${displayNameId}`)
      ? t(`dynamic.${displayNameId}`)
      : te(`dynamic.${abbreviationId}`)
        ? t(`dynamic.${abbreviationId}`)
        : (name ?? `[${t("global.id")}:${id}]`);
  });

  return filterNames.length === 0
    ? t("components.event-action.filter.ui.badges.FlagsFilterBadge.withoutFlags")
    : joinList(filterNames);
});
</script>

<style lang="scss" scoped></style>
